//datepicker booking
var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');
var opencheck = 0;
var firstClick = 0; 

(function(){

	$(document).ready(function () {
		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		$('#arriveInput').on('change', function(){
			start = $(this).val();
			$('.calendar-block').datepicker("setDate", start)
		})
		$('#departureInput').on('change', function(){
			end = $(this).val();
			$('.calendar-block').datepicker("setDate", end)
		})

		$('.calendar-block').datepicker({
			changeMonth: false,
			dateFormat: 'mm-dd-yy',
			numberOfMonths: 2,
			beforeShowDay: function (date) {

				$.datepicker._defaults.dateFormat = "mm-dd-yy";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date; 
					opencheck = 0;
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
				
					
				}
				//console.log(start);
				//console.log(end);

				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);

				alternativeDates(start, end);
			
			},
			onChangeMonthYear: function () {
				opencheck = 1;
			}
		});
	});

	function alternativeDates(start, end) { 
		let checkin = start.replace(/-/g, "/");
		let checkout = end.replace(/-/g, "/");
		$("#arriveInputAlt").val(checkin);
		$("#departureInputAlt").val(checkout);
	}

	$('.header__book').click(function() {
		$('.header').toggleClass('widget-open');
		$('#bookingBox').toggleClass('open');
		if($('.header').hasClass('nav-open')) {
			$('.header').removeClass('nav-open');
			$('.header__burger-label').text('Menu');
		}
		var text = $('.header__book').text();
		$('.header__book').text(
			text == "Book Now" ? "Close" : "Book Now");
	});

}());